<template>
  <section class="benefits-banner bg-armor">
    <div
      v-if="isMobile"
      class="rotating-text d-flex align-items-center gap-sm">
      <svg-check
        class="rotating-check"
        variant="inverse"/>
      <h3 class="text-white text-uppercase m-0">
        Free
      </h3>
      <h3 class="text-white text-uppercase m-0">
        {{ benefits[activeIndex] }}
      </h3>
    </div>
    <div
      v-else
      class="d-flex justify-content-center align-items-center gap-sm">
      <div
        v-for="(benefit, idx) in benefits"
        :key="benefit"
        class="d-flex justify-content-center align-items-center gap-sm">
        <div
          v-if="idx !== 0"
          class="divider vertical"
          style="width: 1px; height: 2rem; background-color: white; margin-right: 1.5rem;"/>
        <svg-check variant="inverse"/>
        <h3 class="text-white text-uppercase m-0">
          Free {{ benefit }}
        </h3>
      </div>
    </div>
  </section>
</template>


<script setup>
import { onMounted } from 'vue'
import SvgCheck from '@/homepage/components/svg/SvgCheck.vue'
import { ref } from 'vue'
import useScreenSize from '@shared/composables/screenSize'
const { isMobile } = useScreenSize()
const benefits = [
  'Shipping',
  'Cleaning',
  'Styling'
]
const activeIndex = ref(0)
onMounted(() => {
  setInterval(() => {
    activeIndex.value = (activeIndex.value + 1) % benefits.length
  }, 2000)
})

</script>

<style lang="scss" scoped>
.benefits-banner {
  padding: 12px 0;
}

.rotating-check {
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 12px;
}

.rotating-text {
  width: 252px;
  flex-grow: 0;
  flex-shrink: 0;
  margin: 0 auto;

  .benefit {
    width: 100px;
    text-align: left;
    margin-left: 8px;
  }
}

.divider {
  margin-right: 20px;
}
</style>
